import { jeepRallyApi } from "../api";

const baseUrl = "/api/v1/content";

export const getAllContent = () => {
  return jeepRallyApi.get(`${baseUrl}/all`);
};

export const getContentById = (id) => {
  return jeepRallyApi.get(`${baseUrl}/${id}`);
};

export const updateContent = (id, payload) => {
  return jeepRallyApi.put(`${baseUrl}/${id}`, payload);
};
